let mode = 'image'

// Toggle Buttons
let toggleImageGrid = document.getElementById('toggle-image-mode')
let toggleTextGrid = document.getElementById('toggle-text-mode')

// Grid Wrappers
let imageGrid = document.querySelector('.lineup-image-grid-wrapper')
let textGrid = document.querySelector('.lineup-text-grid-wrapper')

toggleTextGrid.addEventListener('click', () => {
    if (mode === 'image') {
        // Update image grid classlist
        toggleImageGrid.classList.remove('active')
        imageGrid.classList.remove('active')
        
        // Update text grid classlist
        toggleTextGrid.classList.add('active')
        textGrid.classList.add('active')
        
        // Update mode variable
        mode = 'text'
    }
})

toggleImageGrid.addEventListener('click', () => {
    if (mode === 'text') {
        // Update image grid classlist
        toggleImageGrid.classList.add('active')
        imageGrid.classList.add('active')

        // Update text grid classlist
        toggleTextGrid.classList.remove('active')
        textGrid.classList.remove('active')

        // Update mode variable
        mode = 'image'
    }
})

let artists = document.querySelectorAll('.image-artist-wrapper')
let textartists = document.querySelectorAll('.text-artist-wrapper')

// Modal Content
let modalWrapper = document.getElementById('lineup-modal-wrapper')
modalWrapper.addEventListener('click', () => {

})

let modalImage = document.getElementById('lineup-modal-artist-image')
let modalName = document.getElementById('lineup-modal-artist-name')
let modalBio = document.getElementById('lineup-modal-artist-bio')
let modalWebsite = document.getElementById('lineup-modal-artist-website')
let webicon = `<i class="fas fa-globe"></i>`
let modalFacebook = document.getElementById('lineup-modal-artist-facebook')
let fbicon = `<i class="fab fa-facebook"></i>`
let modalInstagram = document.getElementById('lineup-modal-artist-instagram')
let instaicon = `<i class="fab fa-instagram"></i>`
let modalTwitter = document.getElementById('lineup-modal-artist-twitter')
let twittericon = `<i class="fab fa-twitter"></i>`
let modalTiktok = document.getElementById('lineup-modal-artist-tiktok')
let tiktokicon = `<i class="fab fa-tiktok"></i>`
let modalSpotify = document.getElementById('lineup-modal-artist-spotify')
let spotifyicon = `<i class="fab fa-spotify"></i>`
let modalBandcamp = document.getElementById('lineup-modal-artist-bandcamp')
let bandcampicon = `<i class="fab fa-bandcamp"></i>`
let modalShop = document.getElementById('lineup-modal-artist-shop')
let shopicon = `<i class="fas fa-shopping-bag"></i>`
let modalProfileLink = document.getElementById('lineup-modal-profile-link')

let modalCloseButton = document.getElementById('lineup-modal-close')
let modalNextButton = document.getElementById('lineup-modal-next')
let modalPreviousButton = document.getElementById('lineup-modal-previous')

let artistCount = null

function nextSlide() {
    if (artistCount === 0) { modalPreviousButton.style.display = 'flex' }
    artistCount += 1
    // Count is now equal to number of artists, need to hide next button
    if (artistCount === artists.length-1) { modalNextButton.style.display = 'none' }
    modalName.innerHTML = `<h4>${artists[artistCount].dataset.name}</h4>`
    modalBio.innerHTML = `<p>${artists[artistCount].dataset.bio}</p>`
    if (artists[artistCount].dataset.website !== "") { modalWebsite.innerHTML = `<a href="${artists[artistCount].dataset.website}" target="_blank">${webicon}</a>` } else { modalWebsite.innerHTML = `` }
    if (artists[artistCount].dataset.facebook !== "") { modalFacebook.innerHTML = `<a href="${artists[artistCount].dataset.facebook}" target="_blank">${fbicon}</a>` } else { modalFacebook.innerHTML = `` }
    if (artists[artistCount].dataset.instagram !== "") { modalInstagram.innerHTML = `<a href="${artists[artistCount].dataset.instagram}" target="_blank">${instaicon}</a>` } else { modalInstagram.innerHTML = `` }
    if (artists[artistCount].dataset.twitter !== "") { modalTwitter.innerHTML = `<a href="${artists[artistCount].dataset.twitter}" target="_blank">${twittericon}</a>` } else { modalTwitter.innerHTML = `` }
    if (artists[artistCount].dataset.tiktok !== "") { modalTiktok.innerHTML = `<a href="${artists[artistCount].dataset.tiktok}" target="_blank">${tiktokicon}</a>` } else { modalTiktok.innerHTML = `` }
    if (artists[artistCount].dataset.spotify !== "") { modalSpotify.innerHTML = `<a href="${artists[artistCount].dataset.spotify}" target="_blank">${spotifyicon}</a>` } else { modalSpotify.innerHTML = `` }
    if (artists[artistCount].dataset.bandcamp !== "") { modalBandcamp.innerHTML = `<a href="${artists[artistCount].dataset.bandcamp}" target="_blank">${bandcampicon}</a>` } else { modalBandcamp.innerHTML = `` }
    if (artists[artistCount].dataset.shopUrl !== "") { modalShop.innerHTML = `<a href="${artists[artistCount].dataset.shopUrl}" target="_blank">${shopicon}</a>` } else { modalShop.innerHTML = `` }
    modalImage.style.backgroundImage = `url(${artists[artistCount].dataset.imageUrl})`
    if (modalProfileLink) { modalProfileLink.href = '/pages/artist?artist=' + artists[artistCount].dataset.handle; }
}

function previousSlide() {
    if (artistCount === artists.length-1) { modalNextButton.style.display = 'flex' }
    artistCount -= 1
    // Count is now zero, need to hide previous button
    if (artistCount === 0) { modalPreviousButton.style.display = 'none' }
    modalName.innerHTML = `<h4>${artists[artistCount].dataset.name}</h4>`
    modalBio.innerHTML = `<p>${artists[artistCount].dataset.bio}</p>`
    if (artists[artistCount].dataset.website !== "") { modalWebsite.innerHTML = `<a href="${artists[artistCount].dataset.website}" target="_blank">${webicon}</a>` } else { modalWebsite.innerHTML = `` }
    if (artists[artistCount].dataset.facebook !== "") { modalFacebook.innerHTML = `<a href="${artists[artistCount].dataset.facebook}" target="_blank">${fbicon}</a>` } else { modalFacebook.innerHTML = `` }
    if (artists[artistCount].dataset.instagram !== "") { modalInstagram.innerHTML = `<a href="${artists[artistCount].dataset.instagram}" target="_blank">${instaicon}</a>` } else { modalInstagram.innerHTML = `` }
    if (artists[artistCount].dataset.twitter !== "") { modalTwitter.innerHTML = `<a href="${artists[artistCount].dataset.twitter}" target="_blank">${twittericon}</a>` } else { modalTwitter.innerHTML = `` }
    if (artists[artistCount].dataset.tiktok !== "") { modalTiktok.innerHTML = `<a href="${artists[artistCount].dataset.tiktok}" target="_blank">${tiktokicon}</a>` } else { modalTiktok.innerHTML = `` }
    if (artists[artistCount].dataset.spotify !== "") { modalSpotify.innerHTML = `<a href="${artists[artistCount].dataset.spotify}" target="_blank">${spotifyicon}</a>` } else { modalSpotify.innerHTML = `` }
    if (artists[artistCount].dataset.bandcamp !== "") { modalBandcamp.innerHTML = `<a href="${artists[artistCount].dataset.bandcamp}" target="_blank">${bandcampicon}</a>` } else { modalBandcamp.innerHTML = `` }
    if (artists[artistCount].dataset.shopUrl !== "") { modalShop.innerHTML = `<a href="${artists[artistCount].dataset.shopUrl}" target="_blank">${shopicon}</a>` } else { modalShop.innerHTML = `` }
    modalImage.style.backgroundImage = `url(${artists[artistCount].dataset.imageUrl})`
    if (modalProfileLink) { modalProfileLink.href = '/pages/artist?artist=' + artists[artistCount].dataset.handle; }
}

function closeModal() {
    modalWrapper.style.display = 'none'
    modalName.innerHTML = ``
    modalImage.innerHTML = ``
    if (modalShop) modalShop.innerHTML = ``
    document.getElementsByTagName('body')[0].style.overflow = 'visible'
}

modalCloseButton.addEventListener('click', closeModal)

document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeModal() }
})

let modalHeight
window.addEventListener('resize', () => {
    modalHeight = document.getElementById('lineup-modal-content').offsetHeight - 150
    document.getElementById('lineup-modal-artist-bio').style.maxHeight = `${modalHeight}px`
})
for (let i = 0; i < artists.length; i++) {
    const artistImage = artists[i].querySelector('.image-artist-image')
    const artistOverlay = artists[i].querySelector('.image-artist-overlay')

    artists[i].querySelector('.open-bio-modal').addEventListener('click', () => {
        artistCount = i
        modalPreviousButton.style.display = 'flex'
        modalNextButton.style.display = 'flex'
        if (artistCount === 0) {
            modalPreviousButton.style.display = 'none'
        }
        if (artistCount === artists.length-1) {
            modalNextButton.style.display = 'none'
        }
        modalWrapper.style.display = 'flex'
        modalName.innerHTML = `<h4>${artists[i].dataset.name}</h4>`
        modalBio.innerHTML = `<p>${artists[artistCount].dataset.bio}</p>`
        if (artists[artistCount].dataset.website !== "") { modalWebsite.innerHTML = `<a href="${artists[artistCount].dataset.website}" target="_blank">${webicon}</a>` } else { modalWebsite.innerHTML = `` }
        if (artists[artistCount].dataset.facebook !== "") { modalFacebook.innerHTML = `<a href="${artists[artistCount].dataset.facebook}" target="_blank">${fbicon}</a>` } else { modalFacebook.innerHTML = `` }
        if (artists[artistCount].dataset.instagram !== "") { modalInstagram.innerHTML = `<a href="${artists[artistCount].dataset.instagram}" target="_blank">${instaicon}</a>` } else { modalInstagram.innerHTML = `` }
        if (artists[artistCount].dataset.twitter !== "") { modalTwitter.innerHTML = `<a href="${artists[artistCount].dataset.twitter}" target="_blank">${twittericon}</a>` } else { modalTwitter.innerHTML = `` }
        if (artists[artistCount].dataset.tiktok !== "") { modalTiktok.innerHTML = `<a href="${artists[artistCount].dataset.tiktok}" target="_blank">${tiktokicon}</a>` } else { modalTiktok.innerHTML = `` }
        if (artists[artistCount].dataset.spotify !== "") { modalSpotify.innerHTML = `<a href="${artists[artistCount].dataset.spotify}" target="_blank">${spotifyicon}</a>` } else { modalSpotify.innerHTML = `` }
        if (artists[artistCount].dataset.bandcamp !== "") { modalBandcamp.innerHTML = `<a href="${artists[artistCount].dataset.bandcamp}" target="_blank">${bandcampicon}</a>` } else { modalBandcamp.innerHTML = `` }
        if (artists[artistCount].dataset.shopUrl !== "") { modalShop.innerHTML = `<a href="${artists[artistCount].dataset.shopUrl}" target="_blank">${shopicon}</a>` } else { modalShop.innerHTML = `` }
        modalImage.style.backgroundImage = `url(${artists[artistCount].dataset.imageUrl})`
        if (modalProfileLink) { modalProfileLink.href = '/pages/artist?artist=' + artists[artistCount].dataset.handle; }
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'

        modalHeight = document.getElementById('lineup-modal-content').offsetHeight - 150
        document.getElementById('lineup-modal-artist-bio').style.maxHeight = `${modalHeight}px`
    })
}

for (let i = 0; i < textartists.length; i++) {
    textartists[i].addEventListener('click', () => {
        artistCount = i
        modalPreviousButton.style.display = 'flex'
        modalNextButton.style.display = 'flex'
        if (artistCount === 0) {
            modalPreviousButton.style.display = 'none'
        }
        if (artistCount === artists.length-1) {
            modalNextButton.style.display = 'none'
        }
        modalWrapper.style.display = 'flex'
        modalName.innerHTML = `<h4>${artists[i].dataset.name}</h4>`
        modalBio.innerHTML = `<p>${artists[artistCount].dataset.bio}</p>`
        if (artists[artistCount].dataset.website !== "") { modalWebsite.innerHTML = `<a href="${artists[artistCount].dataset.website}" target="_blank">${webicon}</a>` } else { modalWebsite.innerHTML = `` }
        if (artists[artistCount].dataset.facebook !== "") { modalFacebook.innerHTML = `<a href="${artists[artistCount].dataset.facebook}" target="_blank">${fbicon}</a>` } else { modalFacebook.innerHTML = `` }
        if (artists[artistCount].dataset.instagram !== "") { modalInstagram.innerHTML = `<a href="${artists[artistCount].dataset.instagram}" target="_blank">${instaicon}</a>` } else { modalInstagram.innerHTML = `` }
        if (artists[artistCount].dataset.twitter !== "") { modalTwitter.innerHTML = `<a href="${artists[artistCount].dataset.twitter}" target="_blank">${twittericon}</a>` } else { modalTwitter.innerHTML = `` }
        if (artists[artistCount].dataset.tiktok !== "") { modalTiktok.innerHTML = `<a href="${artists[artistCount].dataset.tiktok}" target="_blank">${tiktokicon}</a>` } else { modalTiktok.innerHTML = `` }
        if (artists[artistCount].dataset.spotify !== "") { modalSpotify.innerHTML = `<a href="${artists[artistCount].dataset.spotify}" target="_blank">${spotifyicon}</a>` } else { modalSpotify.innerHTML = `` }
        if (artists[artistCount].dataset.bandcamp !== "") { modalBandcamp.innerHTML = `<a href="${artists[artistCount].dataset.bandcamp}" target="_blank">${bandcampicon}</a>` } else { modalBandcamp.innerHTML = `` }
        if (artists[artistCount].dataset.shopUrl !== "") { modalShop.innerHTML = `<a href="${artists[artistCount].dataset.shopUrl}" target="_blank">${shopicon}</a>` } else { modalShop.innerHTML = `` }
        modalImage.style.backgroundImage = `url(${artists[artistCount].dataset.imageUrl})`
        if (modalProfileLink) { modalProfileLink.href = '/pages/artist?artist=' + artists[artistCount].dataset.handle; }
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'

        modalHeight = document.getElementById('lineup-modal-content').offsetHeight - 150
        document.getElementById('lineup-modal-artist-bio').style.maxHeight = `${modalHeight}px`
    })
}

modalNextButton.addEventListener('click',
    function () {
        nextSlide()
    }
)

modalPreviousButton.addEventListener('click',
    function () {
        previousSlide()
    }
)

// Card animation
function initCardFlip() {
  gsap.utils.toArray(".image-artist-wrapper").forEach(function(card) {
    gsap.set(card, {
      transformStyle: "preserve-3d",
      transformPerspective: 1000
    })

    const q = gsap.utils.selector(card)
    const front = q(".front")
    const back = q(".back")

    gsap.set(back, { rotationY: -180 })

    const tl = gsap.timeline({ paused: true })
      .to(front, { duration: .5, rotationY: 180 })
      .to(back, { duration: .5, rotationY: 0 }, 0)
      .to(card, { z: 10 }, 0)
      .to(card, { z: 0 }, 0.25)

    card.addEventListener("mouseenter", function() { tl.play() })
    card.addEventListener("mouseleave", function() { tl.reverse() })
  })
}
initCardFlip()

